export interface PingProfile {
    uid: string;
    first_name: string;
    last_name: string;
}

export enum PingRole {
    Admin = "FMA-Admin",
    Reviewer = "FMA-Reviewer",
    Pilot = "FMA-Pilot"
}